<template>
  <div class="Journalism">
    <div class="JournalismImg">
      <img src="../assets/Journalism.png" alt="" />
    </div>
    <div class="info">
      <div class="info_title">
        <div class="tit">新闻资讯</div>
        <div class="nc">NEWS CENTER</div>
      </div>
      <div v-if="!listShow" class="goback" @click="goback">
        <div class="backImg">
          <img src="../assets/goback.jpg" alt="" />
        </div>
        <div class="back">返回</div>
      </div>
      <div class="list" v-if="listShow">
        <ul>
          <li v-for="(item, index) in list1" :key="index" @click="go(index)">
            <img :src="item" alt="" />
          </li>
        </ul>
      </div>    
      <div
        class="detail"
        v-for="(item, index) in list2"
        v-show="index == idx"
        :key="index"
      >
        <img :src="item" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list1: [
        require("../assets/Journalism01.png"),
        require("../assets/Journalism02.png"),
        require("../assets/Journalism03.png"),
        require("../assets/Journalism04.png"),
        require("../assets/Journalism05.png"),
        require("../assets/Journalism06.png"),
        require("../assets/Journalism07.png"),
        require("../assets/Journalism08.png"),
      ],
      list2: [
        require("../assets/Journalisma1.png"),
        require("../assets/Journalisma2.png"),
        require("../assets/Journalisma3.png"),
        require("../assets/Journalisma4.png"),
        require("../assets/Journalisma5.png"),
        require("../assets/Journalisma6.png"),
        require("../assets/Journalisma7.png"),
        require("../assets/Journalisma8.png"),
      ],
      idx: -1,
      listShow: true,
    };
  },
  methods: {
    go(index) {
      this.idx = index;
      this.listShow = false;
    },
    goback() {
      location.reload();
    },
  },
};
</script>

<style scoped lang="less">
.Journalism {
  margin-bottom: 20px;
}
.JournalismImg {
  width: 100%;
  height: 450px;
  img {
    width: 100%;
    height: 100%;
  }
}
.goback {
  text-align: left;
  margin-left: 30px;
  display: flex;
  align-items: center;
  .backImg {
    width: 25px;
    height: 25px;
    margin-right: 5px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .back {
    color: #00bbff;
    font-weight: 600;
    font-size: 18px;
  }
}
.info {
  width: 1260px;
  margin: 0 auto;
  padding-top: 30px;
  text-align: center;
  margin-top: 20px;
  border: 1px solid #ccc;
  .info_title {
    .tit {
      color: #0d5af7;
      font-size: 24px;
      font-weight: 700;
      margin-bottom: 10px;
    }
    .nc {
      color: #888897;
    }
  }
  .list {
    padding: 0 100px;
    margin-top: 15px;
    ul {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      li {
        width: 35%;
        margin-bottom: 10px;
      }
    }
  }
  .detail {
    margin-top: 15px;
  }
}


</style>
